import script from "./ChooseListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseListView.vue?vue&type=script&setup=true&lang=js"

import "./ChooseListView.vue?vue&type=style&index=0&id=73c64de8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c64de8"]])

export default __exports__